import React from 'react';
import { motion } from 'framer-motion';
export function WaveBackground() {
  // Create a grid of dots
  const rows = 20;
  const cols = 35;
  const dots = [];
  for (let row = 0; row < rows; row++) {
    for (let col = 0; col < cols; col++) {
      dots.push({
        row,
        col,
        id: `${row}-${col}`
      });
    }
  }
  return <div className="fixed inset-0 pointer-events-none overflow-hidden opacity-60" data-id="element-146">
      <div className="relative w-full h-full" data-id="element-147">
        {dots.map(({
        row,
        col,
        id
      }) => {
        // Calculate delay based on position to create wave effect
        const delay = (col * 0.1 + row * 0.05) % 3;
        return <motion.div key={id} className="absolute w-0.5 h-0.5 bg-black rounded-full" style={{
          left: `${col / cols * 100}%`,
          top: `${row / rows * 100}%`
        }} animate={{
          y: [0, -10, 0],
          scale: [1, 1.1, 1]
        }} transition={{
          duration: 3,
          delay,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-148" />;
      })}
      </div>
    </div>;
}